import * as utils from "../lib/utils.js";
import { navigate } from 'gatsby';

export function GetMaxLevel()
{
	return 3;
}

export async function CheckRestApiConnection() {
	try {
	  const response = await fetch(
	    utils.ApiUrl() + "/hello",
	    {
	      method: "GET",
	      headers: {
	        "X-API-Key": utils.ApiKey(),
	      },
	    }
	  );

	  if (!response.ok) {
	    // Handle non-successful responses (e.g., 404, 500)
	    console.error("Error connecting to Rest API");
	    return null; // Or throw an error
	  }

	  
	  //const data = await response.json();
	  console.log("Rest API Online")
	  return true;
	} catch (error) {
	  console.error("Error connecting to Rest API", error);
	  return false; // Or throw the error
	}
}

export async function GetPage(hash) {
	try {
	  const response = await fetch(
	    utils.ApiUrl() + '/page?hash=' + hash,
	    {
	      method: "GET",
	      headers: {
	        "X-API-Key": utils.ApiKey(),
	      },
	    }
	  );

	  if (!response.ok) {
	    // Handle non-successful responses (e.g., 404, 500)
	    console.error("Error fetching page" + hash);
	    return null; // Or throw an error
	  }

	  const data = await response.json();

	  console.log(data);

	  return data;
	} catch (error) {
	  console.error("Error fetching page" + hash, error);
	  return null; // Or throw the error
	}
}

export async function GetSubnode(hash) {
	try {
	  const response = await fetch(
	    utils.ApiUrl() + '/subnode?hash=' + hash,
	    {
	      method: "GET",
	      headers: {
	        "X-API-Key": utils.ApiKey(),
	      },
	    }
	  );

	  if (!response.ok) {
	    // Handle non-successful responses (e.g., 404, 500)
	    console.error("Error fetching countries");
	    return null; // Or throw an error
	  }

	  const data = await response.json();

	  console.log(data);


	  return data;
	} catch (error) {
	  console.error("Error fetching countries", error);
	  return null; // Or throw the error
	}
}

export async function GetMp3(hash) {
	try {
		
		const response = await fetch(utils.ApiUrl() + '/track?hash=' + hash, 
								  {
								  method: 'GET', // Important: Specify the method as GET, even if it's the default
								  headers: {
								    'X-API-Key': utils.ApiKey(), // Replace with your actual API key
									'X-Requested-With': 'XMLHttpRequest' // <-- THIS HEADER IS ESSENTIAL
								  },
								  credentials: 'include'
							  	});

		console.log(response);

		if (response.status === 401) {
			// Authentication required, redirect to login page
			console.error("Authentication required (401). Redirecting to login.");
			navigate('/login');
			return null;
		}
								
		if (response.ok)
		{
			const audioData = await response.json();

			console.log(audioData);


			const mp3Url = Array.isArray(audioData) ? audioData[0]?.mp3Url : audioData?.mp3Url;
			
			//const blob = new Blob([audioData], { type: 'audio/mp3' });
			
			//const url = URL.createObjectURL(blob);
			
			return mp3Url;
		}
		else
		{
			console.error("Request failed with status:", response.status);
			return null;
		}
	
	
	} catch (error) {
	    console.error('Error fetching mp3:', error);
		return null;
	  }
}


export async function getUserInfo() {
    try {
        const response = await fetch(utils.ApiUrl() + '/userinfo', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                // Important: Include credentials if your backend relies on session cookies
                // and you are making cross-origin requests (e.g. dev server on different port)
            },
            credentials: 'include', // Ensure cookies are sent with the request
        });

        if (response.ok) {
            const data = await response.json();
            if (Object.keys(data).length === 0) { // Backend might return empty map if not logged in
                return null;
            }
            return data;
        } else if (response.status === 401 || response.status === 403) {
            console.log('User not authenticated to fetch user info.');
            return null;
        } else {
            console.error('Failed to fetch user info:', response.status, await response.text());
            return null;
        }
    } catch (error) {
        console.error('Error fetching user info:', error);
        return null;
    }
}

